import Typo from "typo-js";
import { Range } from "ace-builds";

export async function enableSpellCheck(editor) {
  // Loading dictionary files
  const affData = await fetch("/dictionaries/en_US.aff").then(r => r.text());

  // const word=fetch('/dictionaries/en_US.aff').then(r => r.ok);
  //   console.log(word);

  const dicData = await fetch("/dictionaries/en_US.dic").then(r => r.text());

  // Initializing Typo.js
  const spell = new Typo("en_US", affData, dicData, { platform: "any" });
  const session = editor.getSession();

  //  red underline
  if (!document.getElementById("ace-spell-style")) {
    const style = document.createElement("style");
    style.id = "ace-spell-style";
    style.textContent = `
      .ace_marker-layer .misspelled {
        position: absolute;
        border-bottom: 2px dotted red;
      }`;
    document.head.appendChild(style);
  }

  // Keep per-line marker tracking to remove precisely
  const lineMarkers = new Map();

  function clearLineMarkers(row) {
    const markers = lineMarkers.get(row);
    if (markers) {
      markers.forEach(id => session.removeMarker(id));
      lineMarkers.delete(row);
    }
  }

  function spellCheckLine(row) {
    clearLineMarkers(row);

    const line = session.getLine(row);
    const ids = [];

    // Match alphabetic runs (>=2 chars)
    const wordRe = /[A-Za-z]{2,}/g;
    let m;

    while ((m = wordRe.exec(line)) !== null) {
      const word = m[0];
      const start = m.index;
      const before = line[start - 1] || "";

      // Skip LaTeX commands and their arguments 
      if (before === "\\") continue;

    
      //Skip math expressions $...$ inline math
      const parts = line.split("$");
      if (parts.length % 2 === 0) {
        // even → we're between dollar pairs
        const offset = m.index;
        let inMath = false;
        let pos = 0;
        for (let i = 0; i < parts.length; i++) {
          pos += parts[i].length;
          if (offset < pos) {
            inMath = i % 2 === 1;
            break;
          }
          pos++; // for the skipped '$'
        }
        if (inMath) continue;
      }

      // Inside equation environment — \begin{equation}...\end{equation}
      if (/\\begin\{equation\}/.test(line) || /\\end\{equation\}/.test(line)) continue;

      // Skip stray symbols
      if (/[{}_^]/.test(word)) continue;

      //Spell-check normal text
      if (!spell.check(word)) {
        const range = new Range(row, start, row, start + word.length);
        const id = session.addMarker(range, "misspelled", "typo", true);
        ids.push(id);
      }
    }

    if (ids.length) lineMarkers.set(row, ids);
  }


  // Listen to text changes and re-check only affected lines
  session.on("change", delta => {
    const start = delta.start.row;
    const end = delta.end.row;

    for (let r = start; r <= end; r++) {
      spellCheckLine(r);
    }
  });

  // Initial full check once
  for (let row = 0; row < session.getLength(); row++) {
    spellCheckLine(row);
  }
}